<template>
  <DpaNewsBanner
    class="flex justify-center gap-x-4 text-neutral-emphasis"
    appearance="surface-level-1">
    {{ message }}
    <UiButton
      size="xs"
      appearance="outline-subtle"
      to="mailto:customer.support@dpa.com">
      <UiIcon name="envelope" />
      {{ t("intelligence.contactSales") }}
    </UiButton>
  </DpaNewsBanner>
</template>

<script setup lang="ts">
import UiButton from "@dpa-id-components/dpa-shared-components/src/components/UiButton/UiButton.vue";
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { differenceInCalendarDays } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import DpaNewsBanner from "@/components/shared/DpaNewsBanner/DpaNewsBanner.vue";
import { useUserStore } from "@/stores/user.ts";

const { t } = useI18n();
const user = useUserStore();

const message = computed(() => {
  if (!user.validToDate) return;
  const days = differenceInCalendarDays(new Date(user.validToDate), new Date());
  if (days <= 1) return t("intelligence.remainingTrialToday");
  return t("intelligence.remainingTrial", { n: days });
});
</script>
